import * as React from 'react';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

interface ZoomImgProps {
  imgSrc: string;
  classImg?: string;
  styleImg?: any;
  hiddenImg?: boolean;
}
export const ZoomImg = (props: ZoomImgProps) =>{
    return (
      <TransformWrapper>
        <TransformComponent>
          <img  src={`${props.imgSrc}`} className={`${props.classImg}`} hidden={props.hiddenImg} style={props.styleImg} alt="Zoom img"/>
        </TransformComponent>
      </TransformWrapper>
    );
}